// react
import React from 'react';

// styles
import { StyledInputAdornment } from './ControlledTimePicker.styles';

// types
import { OffsetAdornmentProps } from './ControlledTimePicker.types';

// utils
import { formatOffset } from 'utils/date';
import dayjs from 'dayjs';

export const CustomTimeOverflowAdornment = React.forwardRef<
  HTMLDivElement,
  OffsetAdornmentProps
>(function CustomTimeOverflowAdornment(props, ref) {
  const { field, time, baseDate, children, ...rest } = props;

  const fieldValue = field?.value
    ? dayjs.isDayjs(field.value)
      ? field.value
      : dayjs(field.value)
    : null;

  const hasValidFieldValue = !!fieldValue && fieldValue.isValid();
  return (
    <StyledInputAdornment ref={ref} {...rest}>
      {hasValidFieldValue &&
        time &&
        formatOffset(time.toDate(), baseDate?.toDate())}
      {children}
    </StyledInputAdornment>
  );
});
